import React from 'react'
import { Box, Button, ThemeProvider } from '@mui/material'
import { Typography } from '../mui/Core/index'
import { useTheme } from '../mui/Styles/index'
import Constants from '../../constants/en.json'
import { routePaths } from '../../constants/routes'

function FallbackComponent() {
  const theme = useTheme()
  const handleLogout = () => {
    localStorage.clear()
    sessionStorage.clear()
    /* Window.location reloads the entire app.
           Do not use anywhere else.
           Window.location satisfies the use case
           here to take user back to login and start
           fresh.
        */
    window.location.replace(routePaths.LOGIN)
  }

  const rootStyle = { alignItems: 'center', textAlign: 'center', mt: '280px' }
  const wentWrongStyle = { fontSize: '24px', fontWeight: '400 !important' }
  const cannotFulfillStyle = { mt: 1 }
  const tryAgainStyle = { mb: 3 }
  return (
    <Box sx={rootStyle}>
      <ThemeProvider theme={theme}>
        <Typography variant='h5' sx={wentWrongStyle}>
          {Constants.fallbackComponent.SOMETHING_WENT_WRONG}:
        </Typography>
        <Typography variant='body2' sx={cannotFulfillStyle}>
          {Constants.fallbackComponent.CANNOT_FULFILL_REQUEST}
        </Typography>
        <Typography variant='body2' sx={tryAgainStyle}>
          {Constants.fallbackComponent.TRY_AGAIN_LATER}
        </Typography>
        <Button variant='contained' onClick={handleLogout}>
          {Constants.fallbackComponent.RETURN_TO_LOGIN}
        </Button>
      </ThemeProvider>
    </Box>
  )
}

export default FallbackComponent
